export default "__VITE_ASSET__Bn7jLxJL__"